<div *ngIf="accountingEmail$ | async as accountingEmail" class="accounting-email">
  <span class="text-n-40">{{ 'checkout.billingInformation.accountingEmail.invoiceEmailSentTo' | transloco }}</span>
  <span class="text-b-40 pl-1"><yat-email-clip id="e6a0c25b-5c54-4448-a388-26a8b1b03670" [email]="accountingEmail"></yat-email-clip></span>
</div>
